import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Contact } from './pages/Contact';
import { WorkIndex } from './pages/WorkIndex';
import { Project } from './pages/Project';
import { Article } from './pages/Article';
import { CookieNotice } from './components/CookieNotice';
import { RevealOnScroll } from './components/RevealOnScroll';
import { useSmoothScroll } from './hooks/useSmoothScroll';
export function App() {
  useSmoothScroll();
  return <BrowserRouter data-id="element-0" data-mp="2mjpw3ffpleft">
      <Routes data-id="element-1" data-mp="31aqfgfhzusqq">
        <Route path="/" element={<Home data-id="element-3" data-mp="31brzvakwgrl4" />} data-id="element-2" data-mp="31b8ka0iq2fa9" />
        <Route path="/work" element={<WorkIndex data-id="element-5" data-mp="31cjpm4rtfv3h" />} data-id="element-4" data-mp="31c9ygdv1bhw7" />
        <Route path="/work/:slug" element={<Project data-id="element-7" data-mp="2wj8g1vvmd07v" />} data-id="element-6" data-mp="2wjgrrkg09zhh" />
        <Route path="/journal/:slug" element={<Article data-id="element-9" data-mp="28tw6guwdqq51" />} data-id="element-8" data-mp="2whx8rm2ytac0" />
        <Route path="/contact" element={<Contact data-id="element-11" data-mp="28sl5f2ubjwhm" />} data-id="element-10" data-mp="28te2td7e19n3" />
        <Route path="/legal/:slug" element={<Legal data-id="element-13" data-mp="23w4ey1znd61d" />} data-id="element-12" data-mp="23vciyq2516ak" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-15" data-mp="23t8iki3g6pf1" />} data-id="element-14" data-mp="23ujho4ly78zt" />
      </Routes>
      <RevealOnScroll data-id="element-16" data-mp="3ikqytzf4l45q" />
      <CookieNotice data-id="element-17" data-mp="3ijfvu1ti80fo" />
    </BrowserRouter>;
}